var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:{
  'cl-input-adornment': true,
  'cl-input-adornment--start': this.position === 'start',
  'cl-input-adornment--end': this.position === 'end'
}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }